import { render, staticRenderFns } from "./ReportBugComponent.vue?vue&type=template&id=3166a4f5&scoped=true"
import script from "./ReportBugComponent.js?vue&type=script&lang=js&external"
export * from "./ReportBugComponent.js?vue&type=script&lang=js&external"
import style0 from "./ReportBugComponent.vue?vue&type=style&index=0&id=3166a4f5&prod&scoped=true&lang=scss"
import style1 from "./ReportBugComponent.vue?vue&type=style&index=1&id=3166a4f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166a4f5",
  null
  
)

export default component.exports